<template>
    <FormSection title="Emergency Preparedness" :full-height="false" :application-id="application" type="his-section">
        <template #content>
            <section class="py-3 pb-0 g-0">
                <div class="row p-2">
                    <div class="col-12 offset-lg-1 col-lg-10">
                        <div class="form-group">
                            <label class="form-label w-100 d-flex align-items-center" for="emergency-triage">
                                <span>Emergency Triage</span>
                                <span class="badge badge-pill badge-app-primary me-1 ms-auto"> New </span>
                                <a
                                    href="https://www.cdc.gov/coronavirus/2019-ncov/index.html"
                                    class="fw-normal"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    COVID-19: CDC Resource Page
                                </a>
                            </label>
                            <div class="btn-group colors w-100" data-bs-toggle="buttons">
                                <label
                                    :class="`w-25 btn btn-outline-primary ${
                                        patient?.emergencyPreparedness.emergencyPreparednessPriority == priority.value
                                            ? ' text-white scale-label active'
                                            : ' text-black'
                                    } border border-secondary`"
                                    v-for="[index, priority] in enumToMap(emergencyPrioritiesEnum)"
                                    :key="priority.value"
                                    @click="selectChange(priority.value)"
                                >
                                    <input class="d-none" type="radio" name="priority" autocomplete="off" />
                                    <p class="fw-bold my-2">{{ priority.name }}</p>
                                    <p class="fw-normal">
                                        {{ emergencyPrioritiesInfo[priority.value] }}
                                    </p>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 offset-lg-1 col-lg-10">
                        <div class="form-group">
                            <label for="emergency-preparedness-information"> Emergency Preparedness Information </label>
                            <div
                                class="form-check px-0"
                                v-for="[index, information] in enumToMap(emergencyPreparednessInformationEnum)"
                                :key="information.value"
                            >
                                <div class="form-check custom-checkbox form-check-inline">
                                    <input
                                        type="checkbox"
                                        class="form-check-input au-target"
                                        :id="`information${information.name}`"
                                        :value="information.value"
                                        @change="emergencyPrepInfoChanged(information.value)"
                                        :checked="
                                            patient.emergencyPreparedness.emergencyPreparednessInformationValues?.includes(
                                                information.value
                                            )
                                        "
                                    />
                                    <label class="form-check-label" :for="`information${information.name}`">
                                        <span class="me-1">{{ information.name }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <CommentInput
                            v-if="showAdditionalInfo"
                            input-name="referral-comments"
                            :result="patient.emergencyPreparedness.additionalEmergencyInformation"
                            v-on:resultUpdatedAppended="resultUpdatedAppended"
                            v-on:resultUpdated="resultUpdated"
                            placeholder="Enter Additional Emergency Preparedness Information"
                            :application="application"
                        />
                    </div>
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script src="./EmergencyPreparednessSection.ts"></script>
